import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Heart } from 'lucide-react';
export function About() {
  return <section className="py-10 md:py-12 px-6 max-w-5xl mx-auto" id="o-naju" data-id="element-11">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} className="bg-white rounded-[3rem] p-6 md:p-10 shadow-soft flex flex-col md:flex-row gap-8 items-center relative overflow-hidden" data-id="element-12">
        {/* Decorative background shape */}
        <div className="absolute -top-20 -right-20 w-64 h-64 bg-brand-pink-light rounded-full opacity-50 blur-3xl" data-id="element-13"></div>

        <div className="w-full md:w-1/3 relative" data-id="element-14">
          <div className="aspect-square rounded-[2rem] overflow-hidden shadow-md border-4 border-brand-cream rotate-3" data-id="element-15">
            <img src="https://cdn.magicpatterns.com/uploads/9pozpMXvQ9sNnhbdj3oGty/f7dd9abe-44e6-45fb-906e-71da18f5831d.jpg" alt="Eli in Ema, sestri, ki sprehajata pse v Sloveniji" width={800} height={800} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-16" />
          </div>
          <div className="absolute -bottom-4 -right-4 bg-brand-green p-3 rounded-full shadow-lg" data-id="element-17">
            <Heart className="w-8 h-8 text-white fill-white" data-id="element-18" />
          </div>
        </div>

        <div className="w-full md:w-2/3 z-10" data-id="element-19">
          <h2 className="font-display text-4xl font-bold text-brand-text mb-6" data-id="element-20">
            O nama
          </h2>
          <div className="space-y-4 text-lg text-brand-text/80 leading-relaxed" data-id="element-21">
            <p data-id="element-22">
              Sva sestri iz{' '}
              <strong className="text-brand-brown" data-id="element-23">okolice Krškega</strong>, ki
              že od nekdaj obožujeva živali. Imava veliko izkušenj z nego in
              skrbjo za pse ter druge hišne ljubljenčke, saj so vedno del
              najinega življenja.
            </p>
            <p data-id="element-24">
              Zavedava se, da je vsak kuža poseben, zato k vsakemu pristopiva z
              veliko mero{' '}
              <strong className="text-brand-brown" data-id="element-25">
                odgovornosti, potrpežljivosti in prijaznosti
              </strong>
              . Najina največja motivacija je iskrena ljubezen do živali in
              želja, da vašemu kosmatincu polepšava dan, ko vi nimate časa.
            </p>
          </div>
        </div>
      </motion.div>
    </section>;
}